import { render, staticRenderFns } from "./exportDataPage.vue?vue&type=template&id=2bf91aa6&scoped=true"
import script from "./exportDataPage.vue?vue&type=script&lang=js"
export * from "./exportDataPage.vue?vue&type=script&lang=js"
import style0 from "./exportDataPage.vue?vue&type=style&index=0&id=2bf91aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf91aa6",
  null
  
)

export default component.exports